import { SettingConst } from '@faire/web-api--source/types';

/**
 * To be turned on before FAIRE_DIRECT_WIDGET_INSTALLATION_CX_CHAT_240918. There is a small change
 * to the help center that we want to gate until CX is ready.
 */
export const FAIRE_DIRECT_WIDGET_INSTALLATION_SELF_SERVE_241007 =
  'FAIRE_DIRECT_WIDGET_INSTALLATION_SELF_SERVE_241007' as SettingConst<
    'FAIRE_DIRECT_WIDGET_INSTALLATION_SELF_SERVE_241007',
    boolean,
    'HELP_CENTER'
  >;
